import { render, staticRenderFns } from "./IndustryWorkshop.vue?vue&type=template&id=a38c7bdc&scoped=true&"
import script from "./IndustryWorkshop.vue?vue&type=script&lang=js&"
export * from "./IndustryWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./IndustryWorkshop.vue?vue&type=style&index=0&id=a38c7bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38c7bdc",
  null
  
)

export default component.exports